<template>
    <div class="wrapper reveal-side-navigation">
        <span><strong>TestMode: </strong>{{this.testMode}}</span><br />
        <span><strong>Date Now: </strong>{{this.dtNow}}</span><br />
        <span><strong>Date Now Formatted: </strong>{{this.dtNowFormatted}}</span>
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as dayjs from 'dayjs'
import utc from "dayjs/plugin/utc";

export default {
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://airoluggage.com/test'}
    ]
  },
    data() {
        return {
            dtNow: null,
            dtNowFormatted: null,
        }
    },
    computed: {
        ...mapState("general", ["testMode"]),
    },
    created() {
        dayjs.extend(utc);
    },
    mounted() {
        this.dtNow = dayjs();
        this.dtNowFormatted = dayjs(this.dtNow).utc().format();
        this.$store.dispatch("general/setTestMode");
        this.$store.dispatch("pricing/setupTestBooking");
        this.$router.push('/booking');
    },
};
</script>

<style lang="scss" scoped>
</style>